export const photoCaptureUpdateTNCReducer = (state, action) => {
    return Object.assign(Object.assign({}, state), { isTermsAndConditionAccepted: action.payload });
};
//# sourceMappingURL=photoCaptureUpdateTNCReducer.js.map